export enum ALIGNMENT {
  LEFT = 'left',
  CENTER = 'center',
}